import React from 'react';
import { formatNumber, formatCurrency } from '../../utils/InfluencerIQ/format';

const PlatformIcon = ({ platform }) => {
  const icons = {
    instagram: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
    youtube: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
      </svg>
    ),
    tiktok: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
      </svg>
    ),
    twitter: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    )
  };
  
  return icons[platform] || null;
};

const InfluencerTable = ({ influencers, onViewDetails }) => {
  return (
    <div className="influencers-table-container">
      <div className="table-header-row">
        <span className="table-header-icon">☆</span>
        <h3 className="table-header-title">Recommended Influencers</h3>
      </div>
      
      <table className="influencers-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Influencer</th>
            <th>Platform</th>
            <th>Followers</th>
            <th>Engagement Rate</th>
            <th>Total Engagements</th>
            <th>EMV</th>
            <th>Score</th>
            <th>Risk</th>
            <th>Action Insights</th>
          </tr>
        </thead>
        <tbody>
          {influencers.map((influencer, index) => (
            <tr key={influencer.id}>
              <td>
                <span className="influencer-rank">#{index + 1}</span>
              </td>
              <td>
                <span className="influencer-name">{influencer.name}</span>
              </td>
              <td>
                <span className="platform-badge">
                  <span className="platform-icon">
                    <PlatformIcon platform={influencer.platformIcon} />
                  </span>
                  {influencer.platform}
                </span>
              </td>
              <td>
                <span>👥 {formatNumber(influencer.followers)}</span>
              </td>
              <td>
                <span className="engagement-rate">♡ {influencer.engagementRate}%</span>
              </td>
              <td>
                <span>◯ {formatNumber(influencer.totalEngagements)}</span>
              </td>
              <td>
                <span className="emv-value">$ {formatCurrency(influencer.emv).replace('$', '')}</span>
              </td>
              <td>
                <span className="score-badge">{influencer.score}</span>
              </td>
              <td>
                <span className={`risk-badge ${influencer.risk.toLowerCase()}`}>
                  ✓ {influencer.risk}
                </span>
              </td>
              <td className="action-insights-cell">
                <div className="insights-category">
                  <div className="insights-label strengths">↗ Strengths</div>
                  <ul className="insights-list">
                    {influencer.actionInsights.strengths.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className="insights-category">
                  <div className="insights-label considerations">↘ Considerations</div>
                  <ul className="insights-list">
                    {influencer.actionInsights.considerations.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className="insights-category">
                  <div className="insights-label actions">◉ Actions</div>
                  <ul className="insights-list">
                    {influencer.actionInsights.actions.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
                <button 
                  className="view-details-btn"
                  onClick={() => onViewDetails(influencer)}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  View Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InfluencerTable;
